module.exports = __webpack_public_path__ + "img/162.19537502.jpg";